'use strict';

// Lot workspace — a production/validation lot tied to a MixDesign + Contract, holding the line items sampled from
// it (LineItemLot association). Overview + a Line Items association tab + a "Sub Lots" tab that NESTS each sub lot's
// per-customer metadata (SubLotMetadata) in the shared guided-metadata editor. See source/providers/LotWorkspace-Provider.js.
const libLotWorkspaceProvider = require('../providers/LotWorkspace-Provider.js');

module.exports = {
	Identifier: 'LotWorkspace', Ordinal: 257,
	ProviderClass: libLotWorkspaceProvider,
	Entity: { Name: 'Lot', IDField: 'IDLot', Collection: 'Lots', GUIDField: 'GUIDLot' },
	Header: { Eyebrow: 'Lot', Title: (r) => r.Name || `Lot ${r.IDLot}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Lot/List' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'sublots', Label: 'Sub Lots', Icon: 'fas fa-boxes-stacked', Content: { kind: 'render', ref: '_subLotsHTML' }, OnEnter: (prov) => prov._ensureSubLotsAsync() },
		{ Key: 'lineitems', Label: 'Line Items', Icon: 'fas fa-list-ul', Content: { kind: 'assoc', ref: 'LineItemLot' } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'StartDate', Label: 'Start Date', Format: 'date' }, { Key: 'ValidationSequence', Label: 'Validation Sequence', Format: 'number' } ] },
		{ Name: 'Relationships', Fields: [ { Key: 'IDMixDesign', Label: 'Mix Design', Card: 'MixDesign' }, { Key: 'IDContract', Label: 'Contract', Card: 'Contract' } ] },
	],
	CSSExtra: /*css*/`
		.lw-help { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.9rem; line-height:1.5; }
		.lw-note { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); padding:0.7rem 0.1rem; }
		.lw-error { font-size:0.88rem; color:var(--theme-color-status-error,#b3382f); background:var(--theme-color-status-error-bg,#fbeaea); border-radius:6px; padding:0.5rem 0.7rem; margin:0 0 0.6rem; }
		.lw-sublots { display:flex; flex-direction:column; gap:0.5rem; }
		.lw-sublot { border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:8px; overflow:hidden; background:var(--theme-color-background,#fff); }
		.lw-sublot.is-open { border-color:var(--theme-color-border,#d5dbe3); }
		.lw-sublot-head { display:flex; align-items:center; justify-content:space-between; gap:0.8rem; width:100%; text-align:left; cursor:pointer; padding:0.6rem 0.85rem; border:0; background:transparent; color:var(--theme-color-text-primary,#1f2733); }
		.lw-sublot-head:hover { background:var(--theme-color-background-secondary,#f5f7fa); }
		.lw-sublot-name { font-size:0.95rem; font-weight:600; display:inline-flex; align-items:center; gap:0.55rem; min-width:0; }
		.lw-sublot-name .fas { color:var(--theme-color-text-muted,#8a94a3); font-size:0.78em; width:0.8em; }
		.lw-sublot-summary { font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); font-variant-numeric:tabular-nums; text-align:right; }
		.lw-sublot-body { padding:0.4rem 0.95rem 0.95rem; border-top:1px solid var(--theme-color-border-light,#eef1f6); }
		.lw-sublot-body[hidden] { display:none; }
	`,
};
